export const FUTURE_FUNDING_ROAS_SOURCE = {
  HILL: 'hill',
  GENERAL: 'general',
};

/** Whether new marketing / funding uses spend-based Hill ROAS vs the general vector. */
export function resolveUseHillRoasForFunding(state, hillModel) {
  if (!hillModel) {
    return false;
  }
  return state?.futureFundingRoasSource !== FUTURE_FUNDING_ROAS_SOURCE.GENERAL;
}
